<template>
  <div class="onlineMatchPage">
    <h1 style="color: red;font-size:18px;">注意：请确认一下信息是否为患者本人，确认后，患者信息将不可修改</h1>
    <div class="patientInfo">
      <div>
        <p>报到时间：{{patientInfo.checkin_time}}</p>
        <p>姓名：{{patientInfo.real_name}}</p>
        <p>生日：{{patientBirthDay}}</p>
        <p>身高：{{patientInfo.height}}</p>
      </div>
      <div>
        <p>身份证号：{{patientInfo.id_number}}</p>
        <p>电话：{{patientInfo.mobile}}</p>
        <p>性别：{{patientInfo.gender === 1 ? '男' : '女'}}</p>
        <p>体重：{{patientInfo.weight}}</p>
      </div>
      <div class="avatar">
        <viewer :images="idNumImage" v-if="patientInfo.id_number_image_url" class="imgWrapper">
          <img :src="idNumImage || ''" >
        </viewer>
      </div>
    </div>
    <div class="formWrapper">
      <Form layout="inline" v-for="(item, index) in InformedConsent" :key="index">
        <FormItem :label="item.title" :required="item.type === 'radio'">
          <RadioGroup v-model="item.answer" >
            <Radio value="是" :class="{changeRadio: item.answer ==='是'}">是</Radio>
            <Radio value="否">否</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem v-for="(val, index) in item.child" :key="index" :label="val.name" :required="item.answer === '是'">
          <RadioGroup v-model="val.answer" v-if="val.type === 'radio'" :disabled="item.answer === '否'">
            <Radio value="是" :class="{changeRadio: val.answer ==='是'}">是</Radio>
            <Radio value="否">否</Radio>
          </RadioGroup>
          <Input v-else v-model="val.answer" :disabled="item.answer === '否'"></Input>
          <FormItem v-for="(data, index) in val.child" :key="index" :label="data.name" :required="val.answer === '否'">
            <Input v-model="data.answer" :disabled="val.answer === '是' || val.answer === ''"></Input>
          </FormItem>
        </FormItem>
      </Form>
      <Form layout="inline">
        <FormItem label="签名人与患者关系">
          <span>{{patientInfo.signer_relation}}</span>
        </FormItem>
        <span class="patientSign">
          <viewer :images="signImage" class="imgWrapper">
            <img :src="signImage[0]" >
          </viewer>
        </span>
      </Form>
    </div>
    <div class="footer">
      <div>
        <Button @click="closeMatchModal">取消</Button>
        <Button type="primary" @click="handleSureMatch" :loading="loadingFlag">确认</Button>
      </div>
    </div>
  </div>
</template>

<script>
import { Form, Radio, Input, Button } from 'ant-design-vue'
import { getPatientAgreeBook, changePatientAgreeBook } from '../../api/onlineCheckin'
import { toast } from '../../libs/utils'
export default {
  props: {
    patientId: {
      type: Number,
      default: 8
    }
  },
  data () {
    return {
      patientInfo: {},
      InformedConsent: [],
      canChange: false,
      idNumImage: [],
      signImage: [],
      patientBirthDay: '',
      loadingFlag: false
    }
  },
  components: {
    Form,
    FormItem: Form.Item,
    Radio,
    RadioGroup: Radio.Group,
    Input,
    Button
  },
  async mounted () {
    let data = await getPatientAgreeBook({ id: this.patientId })
    if (data) {
      this.InformedConsent = JSON.parse(data.informed_consent_document)
      this.patientBirthDay = data.birth_date.substring(0, 10)
      this.patientInfo = data
      if (this.patientInfo.id_number_image_url) {
        this.idNumImage.push(this.patientInfo.id_number_image_url)
      }
      this.signImage.push(this.patientInfo.signer_image_url)
    }
  },
  methods: {
    async handleSureMatch () {
      if (this.loadingFlag) return false
      this.loadingFlag = true
      for (let i = 0; i < this.InformedConsent.length; i++) {
        let item = this.InformedConsent[i]
        if (!item.answer) {
          this.loadingFlag = false
          return toast({ title: '提示', type: 'warning', msg: '请填写必填项' })
        }
        if (item.showchild === '是' && item.answer === '是') {
          for (let j = 0; j < item.child.length; j++) {
            let val = item.child[j]
            if (!val.answer) {
              this.loadingFlag = false
              return toast({ title: '提示', type: 'warning', msg: '请填写必填项' })
            }
          }
        }
      }
      this.patientInfo.informed_consent_document = JSON.stringify(this.InformedConsent)
      this.patientInfo.matchFlag = true
      let data = await changePatientAgreeBook(this.patientInfo)
      if (data) {
        this.loadingFlag = false
        this.$emit('handleSureMatch', this.patientInfo)
      }
    },
    closeMatchModal () {
      this.$emit('closeMatchModal')
    }
  }
}
</script>

<style lang="less">
@import url('../../style/index.less');
.onlineMatchPage{
  .patientInfo{
    display: flex;
    justify-content: space-between;
    .avatar{
      width: 100px;
      height: 150px;
      img{
        width: 100%;
        height: 100%;
      }
    }
  }
  .formWrapper{
    .patientSign{
      .imgWrapper{
        display: inline;
      }
      img{
        width:150px;
        height: 60px;
      }
    }
    .ant-input{
      color: red !important;
    }
    .changeRadio{
      color: red;
    }
  }
  .footer{
    .modalFooter();
  }
}
.viewer-open{
  .viewer-backdrop {
    background-color: #fff;
  }
}
</style>